import React from "react";
import Skeleton from "react-loading-skeleton";
import "react-loading-skeleton/dist/skeleton.css";
import { motion } from "framer-motion";

const SearchResultPropertyCardSkeleton = () => {
  return (
    <motion.div
      className="w-full h-[302px] border-[1px] border-[#F0F0F0] rounded-[8px] property-box"
      initial={{ opacity: 0 }}
      animate={{ opacity: 1 }}
      transition={{ duration: 0.5 }}
    >
      <div className="w-full h-full border-[1px] border-[#F0EFFB] rounded-[8px] overflow-hidden">
        <p className="h-[165px]">
          <Skeleton height="100%" />
        </p>
        <div className="p-3">
          <Skeleton width={130} height={30} />
          <Skeleton style={{ marginTop: 12 }} width="90%" height={20} />
          <Skeleton style={{ marginTop: 5 }} width="80%" height={20} />
          <Skeleton style={{ marginTop: 5 }} width="50%" height={15} />
        </div>
      </div>
    </motion.div>
  );
};

export default SearchResultPropertyCardSkeleton;
